enum BackupStatus {
  None = 'NONE',
  Never = 'NEVER',
  AllMeetings = 'ALL_MEETINGS',
  OneMeetingNotBackedUp = 'ONE_MEETING_NOT_BACKED_UP',
  TwoOrMoreMeetingsNotBackedUp = 'TWO_OR_MORE_MEETINGS_NOT_BACKED_UP',
  Dormant = 'DORMANT',
  AllButDormant = 'ALL_BUT_DORMANT',
}

export default BackupStatus;
